export default __webpack_public_path__ + "static/media/testimonial-bg.447e37b2.png";